export default {
  styleOverrides: {
    root: () =>
      ({
        boxShadow: 'none',
        textTransform: 'none' as const,
      }),
  },
};
